import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Button, Form, Grid, Input } from "semantic-ui-react";

const AssistantCcEmail = observer(({ address, onChange, deleteEmail, t }) => (
  <Grid verticalAlign="bottom">
    <Grid.Row columns={2}>
      <Grid.Column width={12}>
        <Form.Field
          control={Input}
          value={address}
          placeholder={t("emailAddress")}
          onChange={event => onChange(event.target.value)}
        />
      </Grid.Column>
      <Grid.Column className="assistants-email-delete-wrap" width={4}>
        <Button type="button" circular icon="trash" color="red" onClick={deleteEmail} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
));

AssistantCcEmail.propTypes = {
  address: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  deleteEmail: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AssistantCcEmail);
